import { render } from "./LeadNotesForm.vue?vue&type=template&id=2e4478bc&scoped=true"
import script from "./LeadNotesForm.vue?vue&type=script&lang=js"
export * from "./LeadNotesForm.vue?vue&type=script&lang=js"

import "./LeadNotesForm.vue?vue&type=style&index=0&id=2e4478bc&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e4478bc"]])

export default __exports__